import axios from "axios";
import { getApiBaseUrl } from "../../services/api";

const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
});

export default axiosClient;